<template>
  <!-- Keyed by OwnerKey: navigating between two fab-owning views never nulls
       MenuItems (entering view claims before leaving view clears — B17), so
       without the key the instance is reused and the hint label cycle in
       CustomIonFabMenu's onMounted never replays for the new view. -->
  <CustomIonFabMenu
    v-if="MenuItems && MenuItems.length > 0"
    :key="OwnerKey ?? undefined"
    :menuItems="MenuItems"
    :showButtonText="true"
    class="app-fab-menu"
  />
</template>
<script lang="ts">
import CustomIonFabMenu from "@/components/ionic/CustomIonFabMenu.vue";
import { useIonFabButtonStore } from "@/stores/core/ionFabButtonStore";
import { storeToRefs } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFabMenu",
  components: { CustomIonFabMenu },
  setup() {
    const ionFabButtonStore = useIonFabButtonStore();
    const { MenuItems, OwnerKey } = storeToRefs(ionFabButtonStore);
    return { MenuItems, OwnerKey };
  },
});
</script>
